import {Component} from '@angular/core';

@Component({
  selector: 'app-hashtag',
  templateUrl: './hashtag.component.html',
  styleUrl: './hashtag.component.scss'
})
export class HashtagComponent {
  showDashboard: boolean = true;
}
